import { render, staticRenderFns } from "./gym_form.vue?vue&type=template&id=83937392&scoped=true&"
import script from "./gym_form.vue?vue&type=script&lang=js&"
export * from "./gym_form.vue?vue&type=script&lang=js&"
import style0 from "./gym_form.vue?vue&type=style&index=0&id=83937392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83937392",
  null
  
)

export default component.exports